
import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { StatiquePageService } from '../../Service/statique-page.service';
import { SharedService } from 'src/app/Service/shared.service';
import * as xml2js from 'xml2js';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-offre-de-formation',
  templateUrl: './offre-de-formation.component.html',
  styleUrls: ['./offre-de-formation.component.scss']
})
export class OffreDeFormationComponent implements OnInit {

  constructor(private global: Global,  private shared: SharedService, private service: StatiquePageService, private router: Router) {
  }
  bloc = {
    Titre: "",
    Contenu: ""
  }
   
  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {      
      this.shared.getBlocDescriptionByCode(lg.url, "offre-de-formation").subscribe(data => {
        this.bloc.Titre = data["value"][0] ? data["value"][0].Title : "";
        this.bloc.Contenu = data["value"][0] ? data["value"][0].Contenu : "";
      })
      this.service.getPageByName("offre-de-formation", lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          const url = this.global._baseUrlRacine + encodeURIComponent(datas['value'][0].File.ServerRelativeUrl);
          $('#offre-de-formation').load(url,()=>{
            $('#offre-de-formation style').remove();
          });
        } else {
          this.router.navigate(['/']);
        }
      });
    })
  }

}
